import type { RouteLocationRaw } from "vue-router"

interface PermissionRefreshNavigationOptions {
  currentPath: string
  currentFullPath: string
  currentRouteAccessible: boolean
  firstAccessibleRouteName?: string | symbol
  replayAccessibleCurrentRoute: boolean
}

function isInternalErrorLanding(path: string) {
  const normalizedPath = path.split(/[?#]/, 1)[0]
  return normalizedPath === "/403" || normalizedPath === "/404"
}

export function resolvePermissionRefreshTarget({
  currentPath,
  currentFullPath,
  currentRouteAccessible,
  firstAccessibleRouteName,
  replayAccessibleCurrentRoute,
}: PermissionRefreshNavigationOptions): RouteLocationRaw | undefined {
  if (currentRouteAccessible && !isInternalErrorLanding(currentPath)) {
    return replayAccessibleCurrentRoute ? `/redirect${currentFullPath}` : undefined
  }
  if (firstAccessibleRouteName) {
    return { name: firstAccessibleRouteName }
  }
  return currentPath === "/403" ? undefined : "/403"
}
